import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import type { Node_Type } from 'ricos-schema';

/**
 * This decoration plugin wraps target node children with spans.
 * This is explicitly used for nodes which has backgroundColor styles on ThemeAPI
 * but actual background color needs to be applied as for inline text.
 */
export const createSpanWrapperDecorationPlugin = (targetNodeType: Node_Type) => {
  return new Plugin({
    key: new PluginKey(`${targetNodeType}-span-wrapper`),
    props: {
      decorations(state) {
        const decorations: Decoration[] = [];

        state.doc.descendants((node, pos) => {
          if (node.type.name === targetNodeType) {
            decorations.push(Decoration.inline(pos, pos + node.nodeSize, { nodeName: 'span' }));
          }
        });

        return DecorationSet.create(state.doc, decorations);
      },
    },
  });
};
